const en = {
  "Home": "Home",
  "Add": "Add",
  "Adding": "Adding",
  "Editing": "Editing",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "Cancel": "Cancel",
  "Close": "Close",
  "Open": "Open",
  "Users": "Users",
  "Are you sure you want to logout": "Are you sure you want to logout?",
  "Name": "Name",
  "Password": "Password",
  "Email": "Email",
  "Active": "Active",
  "UserIsActive": "User is active",
  "Filter": "Filter",
  "Clear": "Clear",
  "Code": " Code",
  "Actions": "Actions",
  "Confirm Dialog": "Confirm Dialog",
  "User": "User",
  "Are you sure that you want to delete": "Are you sure that you want to delete",
  "Role": "Role",
  "Region": "Region",
  "Administrator": "Administrator",
  "ProductManager": "Product Manager",
  "RegionalManager": "Regional Manager",
  "Trader": "Trader",
  "Yes": "Yes",
  "No": "No",
  "Login": "Login",
  "Please enter email": "Please enter email.",
  "Please enter Password": "Please enter password.",
  "Invalid E-mail or Password.": "Invalid email or password.",
  "Invalid E-mail.": "Invalid email",
  "Not found E-mail.": "Invalid email or password.",
  "Logout": "Logout",
  "Mobile": "Mobile",
  "You are not authorized to access this application.": "You are not authorized to access this application.",
  "Profile": "Profile",
  "CurrentPassword": "Current password",
  "NewPassword": "New password",
  "Change": "Change",
  "FillCurrentPassword": "Please fill current password",
  "FillNewPassword": "Please fill new password",
  "Password successfully changed": "Password was changed successfully",
  "Change password": "Change password",
  "Please repeat password": "Please repeat the password.",
  "Passwords dont match": "Passwords don't match.",
  "RepeatPassword": "Repeat password",
  "Data synchronization": "Data synchronization ...",
  "Please wait": "Please wait.",
  "Creating": "Creating",
  "Opening": "Opening",
  "Creating a new offer": "Creating a new offer",
  "Opening an existing offer": "Opening an existing offer",
  "new offer": "new offer",
  "existing offer": "an offer",
  "Offers": "Offers",
  "Phone": "Phone",
  "Edit user data": "Edit user data",
  "Profile data succesfully saved": "Profile data succesfully saved.",
  "1008": "Current password is wrong",
  "Previous": "Previous",
  "Next": "Next",
  "ClientData": "Offer data",
  "TwoDPlan": "Two-dimensional plan",
  "GasInstallation": "Gas Installation",
  "HeatingInstallation": "Heating Installation",
  "InstallationServices": "Installation Services",
  "Gas and heating installations": "Gas and heating installations",
  "ConstructionWork": "Construction Work",
  "QuantitativeAccount": "Quantitative Account",
  "GenerateOffer": "Generate Offer",
  "Disctrict": "Disctrict",
  "Municipality": "Municipality",
  "Town": "Town",
  "Address": "Address",
  "Finish": "Finish",
  "WorkAndMaterials": "With work and materials",
  "BuildingType": "Building Type",
  "Brick": 'Brick',
  "Panel": "Panel",
  "EPK": "EPK",
  "IsolationType": "Isolation Type",
  "RoomHeight": "Room Height",
  "Position": "Position",
  "Client": "Client",
  "New": "New",
  "PipeInstall": "Pipe Installation",
  "Floor": "On floor",
  "Ceiling": "On ceiling",
  "WorkAndMaterialsAndSMR": "Construction Work",
  "Manager": "Manager",
  "Number": "Number",
  "Date": "Date",
  "Are you sure that you want to delete selected offer with ": "Are you sure that you want to delete selected offer with ",
  "None": "None",
  "Inside": "Inside",
  "Outside": "Outside",
  "InsideAndOutside": "Inside and outside",
  "Cannot get clients from local db": "Problem while loading data for clients from local db.",
  "Cannot get locations from local db": "Problem while loading data for locations from local db.",
  "Article": "Article",
  "Product is already added": "Product is already added!",
  "Synchronization": "Synchronization",
  "local data with database": "data with database",
  "Problem saving offer in local db.": "A problem occur while saving offer in local database. Please try again.",
  "Cannot get offer from local db": "A problem occur while getting an offer from local database. Please try again.",
  "Cannot get offers from local db": "A problem occur while getting offers from local database. Please try again..",
  "Cannot edit offer in local db": "A problem occur while saving offer in local database. Please try agaian",
  "Offer edited successfully": "Offer has been edited successfully",
  "GasInstallScheme": "Gas installation scheme",
  "HeathInstallScheme": "Heath installation scheme",
  "Cannot get products from local db": "A problem occur while getting articles from local database. Please try again.",
  "Problem deleting offer": "A problem occur while deleting an offer from lolal storage. Please try again.",
  "Cannot delete offer, offer is already sent": "Can not delete the offer because offer is already sent to the administration.",
  "Offer deleted successfully": "Offer has been deleted successfully.",
  "Creating new offer": "Creating new offer",
  "Editing an offer": "Editing an offer",
  "InCreate": "In create",
  "NewOffer": "New",
  "ContractAgreed": "Contract agrred",
  "InProcess": "In process",
  "ContractCompleted": "Contract completed",
  "Status": "Status",
  "Price": "Price",
  "BGN": "BGN",
  "EUR": "EUR",
  "Search by article number, name, brand, power, supplier...": "Search by article number, name, brand, power, supplier...",
  "AxonometricScheme": "Axonometric Scheme",
  "Disclaimer": "Disclaimer",
  "Qty": "Qty.",
  "UnitShort": "Unit",
  "Services": "Services",
  "UnitNumber": "pcs",
  "UnitLinearMeter": "lm",
  'total records.': 'total records.',
  "Save & Close": "Save & Close",
  "NoGasInstallSchema": "No gas installation schema",
  "NoHeathInstallSchema": "No heath installation schema",
  "Month": "Month",
  "Quarter": "Quarter",
  "Year": "Year",
  "Period": "Period",
  "From": "From",
  "To": "To",
  'DateFormatUS': 'MM/dd/yyyy',
  "From date": "From date",
  "To date": "To date",
  "Offer": "Offer",
  "of": "of",
  "Rows per page": "Rows per page",
  "Filters": "Filters",
  "View all": "View all",
  "No records found": "No records found.",
  'Data Saved Successfully': "Data Saved Successfully",
  "Please enter cleint name.": "Please enter cleint name.",
  "Please enter cleint address.": "Please enter cleint address.",
  "GRT": "GDB",
  "Gas Board": "Gas Distribution Board",
  "GIT": 'GMB',
  "Gas Measuring Board": "Gas Measuring Board",
  "Windows": "Windows",
  "Doors": "Doors",
  "Annotations": "Annotations",
  "Stairs": "Stairs",
  "Circular stairs": "Circular stairs",
  "Round column": "Round column",
  "Square column": "Square column",
  "U Shape": "U Shape",
  "T Shape": "T Shape",
  "Square Shape": "Square Shape",
  "L Shape": "L Shape",
  "Shape": "Shape",
  "Wall": "Wall",
  "Window": "Window",
  "Sash Window": "Sash Window",
  "Venetian Blind Window": "Venetian Blind",
  "Curtain Window": "Curtain Window",
  "Door": "Door",
  "Double Door": "Double Door",
  "Gate": "Gate",
  "Panic Door": "Panic Door",
  "Double Panic Door": "Double Panic Door",
  "Sliding Door": "Sliding Door",
  "Text": "Text",
  "Label": "Label",
  "North Sign": "North Sign",
  "Elevation Sign": "Elevation Sign",
  "Circle Pointer": "Circle Pointer",
  "Chimney Sign": "Chimney Sign",
  "Pipe": "Pipe",
  "Client information": "Client information",
  "Total": "Total",
  "Price without VAT": "Price without VAT",
  "Total without VAT": "Total without VAT",
  "Void": "Void",
  "Void Circle": "Void Circle",
  "Client name": "Client name",
  "Choose client": "Choose client",
  "Client search": "Client search",
  "Choose": "Choose",
  "Search": "Search",
  "Search by name, phone, email": "Search by name, phone, email ...",
  "Cannot get result from client search": "Cannot get result from client search. Please try again.",
  "New client": "New client",
  "Edit client": "Edit client",
  "Edit address": "Edit address",
  "Total after discount": "Total after discount",
  "VAT": "VAT",
  "Signature": "Signature",
  "Sales Representative": "Sales Representative",
  "Phone for contact": "Phone for contact",
  "Accept the offer": "Accept the offer",
  "Discount": "Discount (%)",
  "Installation": "Installation",
  "Total with VAT": "Total with VAT",
  "Validity of the proposal": "Validity of the proposal",
  "to": "to",
  'Copy': 'Copy',
  'Paste': 'Paste',
  'NoTwoDimPlan': 'The selected offer do not have two dimentional plan',
  "Send": "Send",
  "Report offer no network connection": "No network connection. Can't send offer to the administration.",
  "Synchronization please wait": "Data synchronization ... Please wait.",
  "You have not synchronized offers that may be lost. Do you want to logout?": "You have not synchronized offers that may be lost. Are you sure you want to log out?",
  "Fittings": "Fittings",
  "Transitional Holender": "Transitional Holender",
  "Magnet Ventil": "Magnet Ventil",
  "Coupling": "Coupling",
  "Nipel": "Nipel",
  "Triple": "Triple",
  "Ventil": "Ventil",
  "Gas Pipe": "Gas Pipe",
  "Water Pipe": "Water Pipe",
  "GasInstallPrice": "Gas installation (price without VAT)",
  "HeathInstallPrice": "Heath installation (price without VAT)",
  "Services and materials": "Services and materials",
  "Cannot get offers for synchronization from local db": "Cannot get offers for synchronization from local dаtabase.",
  "5001": "An error occurred while processing offers on server. 5001",
  "Cannot set offers as reported": "Cannot set offers as reported in local database.",
  "Cannot set remote ids to newly created offers": "Cannot set remote ids to newly created offers in local database.",
  "Error clearing local database": "Error clearing local database.",
  "5000": "An error occurred receiving data from server. 5000",
  "Error inserting synchronization data from server": "An error occurred while saving data in local database.",
  "Try again": "Try again",
  "Elbow": "Elbow",
  "Installation services": "Installation services",
  "Equipment and materials": "Equipment and materials",
  "Lyre": "Lyre",
  "Bill of quantities": "Bill of quantities",
  "Bill of quantities labor": "Bill of quantities labor",
  "2DScheme": "2D Scheme",
  "Generate": "Generate",
  "vertical pipe": "Vertical pipe",
  "vertical gas pipe": 'Vertical gas pipe',
  "vertical water pipe": "Vertical water pipe",
  "CalculatePipes": "Check gas installation",
  "ProductsPower": "Total consumption:",
  "PipeSumLength": "Pipes length:",
  "PipesDiameter": "Pipes diameter:",
  "Offer recalculation succesfull": "Offer has been successfully recalculated.",
  "Problem recalculating offer": "Problem recalculating offer.",
  "Cannot update offer in local db": "An error occured while updating offer in local database.",
  "AxonometricSchemeG": "Axonometric Scheme of GI",
  "AxonometricSchemeH": "Axonometric Scheme of WHI",
  "GasInstallAxonometry": "Axonometric Scheme of gas installation",
  "HeathInstallAxonometry": "Axonometric Scheme of heath installation",
  "Recalculate Offer": "Recalculate Offer",
  "without vat": "without VAT",
  "Please add at least one item to 2D schema.": "Please add at least one item to 2D schema.",
  "Please add at least one item to Gas installation schema.": "Please add at least one item to Gas installation schema.",
  "Please add at least one item to Heat installation schema.": "Please add at least one item to Heat installation schema.",
  "Index": "Index",
  "AddFittings": "Add Fittings",
  "NoGasPipesFound": "No gas pipes found",
  "NoFittingsFound": "No fittings found",
  "AllFittings": "All fittings",
  "Elbows": "Elbows",
  "Triples": "Triples",
  "Installation articles": "Installation articles",
  "No articles added to installation": "No articles added to installation.",
  "Nipels": "Nipels",
  "Article number": "Article number",
  "Cannot get max diamater from pipes": "Cannot get maximal diamater from pipes",
  "Please add products with power": "Please add products with power!",
  "You have pipes without diameter": "You have pipes without diameter!",
  "Installation is not designed properly": "Installation is not designed properly.",
  "Please add stabilizer or increase pipes diameter": "Please add stabilizer or increase pipes diameter.",
  "Installation is designed properly": "Installation is designed properly",
  "Discount amount without VAT": "Discount amount without VAT",
  "Status changes": "Status changes",
  "Settings": "Settings",
  "Bulgarian": "Bulgarian",
  "English": "English",
  "Language": "Language",
  "Local data": "Local data",
  "Clear local data": "Clear local data",
  "Are you sure you want to clear local data": "Are you sure you want to clear local data?",
  "Get location": "Get location",
  "Get location problem occur": "A problem occur while getting current location. Please try again.",
  "Problem getting data from server. You see only local offers.": "A problem occur while getting data from server. Showing only local offers.",
  "No connection with server. You see only local offers": "No connection with server. Showing only local offers.",
  "Problem deleting offer on server": "An error occured while deleting offer on server.",
  "Offer send successfully": "Offer send successfully",
  "Problem with offer pdf file": "Problem with offer pdf file",
  "AddedFittings": "AddedFittings",
  "Expired": "Expired",
  "Accepted": "Accepted",
  "InExecution": "In execution",
  "Finished": "Finished",
  "Email sending failed": "Email sending failed",
  "SendEmail": "Send to client",
  "Data Saved Successfully Local": "Data has been successfully saved on the device",
  "Data Saved Successfully Server": "Data has been successfully saved in database",
  "Notes": "Notes",
  "AdminNote": "The amount of this price offer is not final and may change. In case that additional services and materials are performed and included, which are not included in the list, they are equalized with a final protocol and invoice. ",
  "Please add email to client data.": "Please add email to client data.",
  "Do you confirm sending": "Do you confirm sending",
  "to client": "to client",
  "with email": "with email",
  '6000': 'Email server is empty',
  '6001': 'Email server port is empty',
  '6002': 'Email user is empty',
  '6003': 'Email user password is empty',
  '6004': 'Email server secure socket is empty',
  '6005': 'Email recipient is empty',
  '6006': 'Email sender is empty',
  '6007': 'Email subjects is empty',
  '6008': 'Email body is empty',
  "Equipment only": "Only delivery and equipment installation",
  "Article No": "Article No",
  "Naming": "Name",
  "Measure": "Measure",
  "Quantity Short": "Qty.",
  "Supplier": "Supplier",
  "Note": "Note",
  "Request for materials": "REQUEST for materials",
  "Request for installation services": "REQUEST for installation services",
  "Request Num": "Request No",
  "Contract Num": "Contract No",
  "Request date": "Request date",
  "Montage address": "Montage address",
  "Montage term": "Montage term",
  "Receiver name": "Receiver name",
  "Contact phone": "Contact phone",
  "Special client requirements": "Special client requirements",
  "Offer status": "Offer status",
  "Profile offline warning msg": "You are currently in offline mode. To edit your profile make sure you are online and try again.",
  "Changed by system": "Changed by system",
  "Article number or name": "Article number or name",
  "Showing from": "Shwoing from",
  "from": "from",
  "copper pipes": "Copper pipes",
  "underground pipes": "Pipes for underground installation",
  "polyethylene pipes with aluminum insert": "Polyethylene pipes with aluminum insert",
  "BDS": "",
  "Tee": "Tee",
  "Tees": "Tees",
  "pcs": "pcs",
  "nipple": "nipple",
  "Nipple": "Nipple",
  "Nipples": "Nipples",
  "nipples": "nipples",
  "w/о VAT": "w/о VAT",
  "Please enter cleint town.": "Please enter cleint town.",
  "Please enter two client names.": "Please enter two client names.",
  "Executed Quantity Short": "Executed Qty.",
  "Delivery address": "Delivery address",
  "Discount (BGN)": "Discount (BGN)",
};

export default en;